module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "overwrite-left"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    },
    slot: "overwrite-left"
  }, [_vm._v(" 关闭")]), _vm._v("\n      重装系统\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('group', {
    staticStyle: {
      "margin": "0 0.1rem",
      "border-radius": "0.3rem"
    },
    attrs: {
      "label-width": "8em"
    }
  }, [_c('popup-picker', {
    attrs: {
      "title": "系统类别",
      "data": _vm.Osname,
      "columns": 1
    },
    model: {
      value: (_vm.Osnamec),
      callback: function($$v) {
        _vm.Osnamec = $$v
      },
      expression: "Osnamec"
    }
  }), _vm._v(" "), _c('popup-picker', {
    attrs: {
      "title": "版本号",
      "show-name": true,
      "data": _vm.Oslist,
      "columns": 1
    },
    model: {
      value: (_vm.Osid),
      callback: function($$v) {
        _vm.Osid = $$v
      },
      expression: "Osid"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "label-width": "6.5em",
      "title": "系统密码",
      "placeholder": "请输入重装后的系统密码",
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group-item code-input-box select-box flex",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('p', {
    staticClass: "left-desc"
  }, [_vm._v("    安装方式")]), _vm._v(" "), _c('div', {
    staticClass: "right-select-box flex1 flex"
  }, _vm._l((_vm.type), function(item, index) {
    return _c('span', {
      staticClass: "another-option",
      class: {
        'selected': _vm.typeid == item.value
      },
      staticStyle: {
        "margin-right": "0.2rem"
      },
      on: {
        "click": function($event) {
          _vm.Choose(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group-item"
  }, [_c('span', {
    staticClass: "form-label",
    staticStyle: {
      "margin-left": "0.3rem"
    }
  }, [_vm._v("\n\t\t\t\t\t\t验证图片\n\t\t\t\t\t")]), _vm._v(" "), _c('img', {
    staticClass: "error-img",
    attrs: {
      "src": _vm.captcha,
      "title": "点击更换"
    },
    on: {
      "click": _vm.changeYzm
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group-item",
    staticStyle: {
      "margin-left": "0.3rem"
    }
  }, [_c('x-input', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "label-width": "6.5em",
      "title": "验证码",
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.yzm),
      callback: function($$v) {
        _vm.yzm = $$v
      },
      expression: "yzm"
    }
  })], 1)], 1), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": "0.2rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert-warn margin-bottom-20 domain-list"
  }, [_c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("操作系统重装前请您提前做好相关备份，以免数据丢失给您造成损失！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e166afe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/serveroperate/reinstallserver.vue
// module id = YnMH
// module chunks = 1